import React,{useEffect} from 'react';
import PostBar from '../Posts/PostBar';

export default function HomePostFeed(){
    return(
        <>
            <PostBar />
        </>
    )
}